const menu = {
  convocatoria: [
    {
      tag: "Acerca de",
      children: [
        {
          path: "/acerca-de/acerca-de",
          tag: "Acerca de",
          name: "acerca de",
        },
        {
          path: "/acerca-de/requisitos-postulacion",
          tag: "Requisitos para postular",
          name: "requisitos",
        },
        {
          path: "/acerca-de/cronograma",
          tag: "Cronograma de postulación",
          name: "cronograma",
        },
        {
          path: "https://www.igp.gob.pe/convocatorias/",
          tag: "Postula aqui",
          name: "postulacion",
        },
      ],
    },
    {
      path: "/charlas",
      tag: "Charlas",
      name: "charlas",
    },
    {
      tag: "Nuestros practicantes",
      children: [
        {
          path: "/nuestros-practicantes/testimonios/2026",
          tag: "Testimonios",
          name: "testimonios",
        },
        {
          path: "/nuestros-practicantes/proyectos/2026",
          tag: "Proyectos",
          name: "proyectos",
        },
      ],
    },
    {
      path: "https://www.igp.gob.pe/convocatorias/",
      tag: "POSTULA AQUI",
      name: "postula",
    },
    {
      path: "/resultados",
      tag: "Resultados",
      name: "resultados",
    },
  ],
};
const trail = [
  {
    path: "https://www.gob.pe/igp",
    tag: "Portal IGP",
    name: "portal",
  },
  {
    path: "/",
    tag: process.env.VUE_APP_TITLE,
    name: "root",
  },
];
const dynamicTrail = [
  {
    tag: "About",
    path: "/acerca-de",
  },
  {
    tag: "Nuestros practicantes",
    path: "/nuestros-practicantes",
  },
];
function getMenu(program) {
  return menu[program] || "convocatoria";
}
function getTrail() {
  return trail;
}
function getDynamicTrail() {
  return dynamicTrail;
}
export { getMenu, getTrail, getDynamicTrail };
